import React from "react";
import MUIDataTable from "mui-datatables";

import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { THEME_COLOR } from "./../../config/config";

const theme = createMuiTheme({
  shadows: Array(5).fill("none"),
  root: {
    "& MuiInputLabel-outlined": {
      zIndex: 0,
    },
    "& MuiTableHead": {
      zIndex: 0,
    },
  },
  overrides: {
    MUIDataTableHeadCell: {
      root: {
        zIndex: 0,
      },
      fixedHeader: {
        zIndex: 0,
      },
      
    },
    MuiTableFooter: {
      root: {
        background: '#f0f2f4',
      },
    },
    MuiTableCell: {
      root: {
        fontSize: "16px", // Custom font size for all table cells
        padding: "8px", // Adjust padding for better spacing
        backgroundColor: "#fafafa", // Light background for all cells
        borderBottom: "1px solid #e0e0e0", // Custom border for rows
        fontSize: "12px",
      },
      head: {
        fontWeight: "bold", // Bold font for header cells
        fontSize: "12px", // Larger font size for header cells
        backgroundColor: "#f5f5f5", // Light gray background for header
        color: "#333", // Darker text color for header cells
      },
    },
    MuiTable: {
      root: {
        borderCollapse: "separate", // Use separated borders for styling
        "@media (max-width: 600px)": {
          fontSize: "12px", // Adjust font size for mobile screens
        },
      },
    },
    MuiPaper: {
      root: {
        overflowX: "auto", // Allow horizontal scrolling for small screens
      },
    },
    MuiToolbar: {
      root: {
        "@media (max-width: 600px)": {
          flexDirection: "column", // Stack toolbar items vertically
          alignItems: "flex-start",
        },
      },
    },
    MuiTablePagination: {
      root: {
        fontSize: "14px", // Adjust pagination font size
      },
    },
  },
  MuiFormLabel: {
    zIndex: 0,
  },
  MuiTableHead: { zIndex: 0 },
  palette: {
    primary: {
      main: THEME_COLOR, //your color
    },
  },
});

export default function DataTable(props) {
  let responsive = "vertical";
  let tableBodyHeight = "100%";
  const options = {
    filter: true,
    responsive,
    tableBodyHeight,
    selectableRows: false,
    rowsPerPage: 50,
    rowsPerPageOptions: [25, 50, 100],
  };

  return (
    <ThemeProvider theme={theme}>
      <div >
        <MUIDataTable
          title={props.title}
          data={props.tableData}
          columns={props.columns}
          options={options}
        />
      </div>
    </ThemeProvider>
  );
}
